import { mapConfig } from "./Config";
import { hbdTrackEvent } from "../modules/hbdTrackEvent";

export class Marker {
    map;
    marker;
    type;
    offset = 0;
    hasPopup = true;
    elementId = "";

    setType(type) {
        this.type = type;
        return this;
    }
    setOffset(offset) {
        this.offset = offset;
        return this;
    }
    setPopup(popup) {
        this.hasPopup = popup;
        return this;
    }

    build(map, marker) {
        this.map = map;
        this.marker = marker;

        let parent = HTMLElement;
        parent = document.createElement("div");
        let element = HTMLElement;

        if (this.type == "marker") {
            // Company
            this.elementId = this.type + this.marker.properties.uid;
        } else if (this.type == "searchPin") {
            // Search
            this.elementId = this.type + this.marker.id;
        } else if (this.type == "reverseSearchMarker") {
            // ReverseSearch
            this.elementId = this.type;
        } else {
            // POI and new Logic
            if (this.marker.properties.uid) {
                parent.id = this.type + this.marker.properties.uid;
            }
            this.elementId = this.type + this.marker.properties.id;
        }
        if ($("#" + this.elementId).length) {
            $("#" + this.elementId).remove();
        }

        if (this.marker.properties.newStyle) {
            // New Way To go !!!
            parent.className = "customPin";
            element = document.createElement("div");
            element.className = "hbdpin " + this.type;
            element.id = this.elementId;

            if (this.type == "routePin") {
                if (element.id.indexOf("waypoint") >= 0) {
                    element.className += " routeWaypoint";
                }
            }
            if (this.marker.properties.tag) {
                element.setAttribute("data-before", this.marker.properties.tag);
            }
        } else if (this.marker.properties["marker-symbol"]) {
            // Company + Search + most POIs
            element = document.createElement("div");
            element.id = this.elementId;
            element.className +=
                this.type + " pin " + this.marker.properties["marker-symbol"];
            if (this.marker.properties["marker-color"]) {
                element.style.backgroundImage =
                    "url('https://a.tiles.mapbox.com/v4/marker/pin-m-" +
                    this.marker.properties["marker-symbol"] +
                    this.marker.properties["marker-color"].replace("#", "+") +
                    ".png?access_token=" +
                    this.map.key +
                    "')";
            } else {
                element.style.backgroundImage =
                    "url('https://a.tiles.mapbox.com/v4/marker/pin-m-" +
                    this.marker.properties["marker-symbol"] +
                    ".png?access_token=" +
                    this.map.key +
                    "')";
            }
        } else if (this.marker.properties.icon) {
            // POIs with special Icon (not regular Pin)
            element = document.createElement("img");
            element.id = this.elementId;
            element.className +=
                this.type + " image " + this.marker.properties.category;
            element.src = marker.properties.icon.iconUrl;
        } else {
            // ReverseSearch + Fallback if something is not covered
            element = document.createElement("img");
            element.id = this.elementId;
            element.setAttribute("src", "/images/mapPins/reverseSearch.svg");
            element.className = this.type + " hbdpin " + "fallback";
            parent.style.zIndex = 101;
        }

        element.setAttribute("data-has-popup", this.hasPopup);
        parent.appendChild(element);

        let markerObject = new mapboxgl.Marker(parent).setLngLat(
            marker.geometry.coordinates
        );

        if (this.hasPopup) {
            let popup = new mapboxgl.Popup({
                offset: this.offset,
                anchor: "top",
            })
                .setDOMContent(
                    new Popup().setType(this.type).build(this.map, this.marker)
                )
                .on("open", (e) => {
                    this.map.currentPopup = popup;
                    let lngLat = e.target._lngLat;
                    let offset = 0 - $(e.target._container).outerHeight() / 3;
                    if (
                        !$("#detailBox.mapview").length &&
                        !$("#searchresult.mapview").length &&
                        !$("body.site_RP").length
                    ) {
                        $(".map-toggle-on").click();
                        setTimeout(() => {
                            this.map.flyMeTo(lngLat, [0, offset]);
                        }, mapConfig.basic.animateDuration);
                    }
                    hbdTrackEvent(
                        "map pin",
                        "click",
                        this.marker.properties.id
                    );
                })
                .on("close", (e) => {});
            markerObject.setPopup(popup);
        }

        markerObject.addTo(this.map.map);

        return markerObject;
    }
}

export class Popup {
    map;
    marker;
    type;

    setType(type) {
        this.type = type;
        return this;
    }

    build(map, marker) {
        this.map = map;
        this.marker = marker;

        let elPopup = document.createElement("div");
        elPopup.className = "popupContentNew";

        let props = this.marker.properties;
        if (!$.isEmptyObject(props)) {
            // all but Reverse-Search
            if (props["iframe_width"]) {
                elPopup.setAttribute(
                    "style",
                    "width: " + props["iframe_width"] + "px;"
                );
            }

            let elClose;
            elClose = document.createElement("span");
            elClose.setAttribute("class", "close");
            elClose.innerHTML = '<i class="icon-close" />';
            elClose.addEventListener("click", function () {
                $(".mapboxgl-popup-close-button").click();
            });
            elPopup.appendChild(elClose);

            if (props.title) {
                let elTitle = document.createElement("div");
                elTitle.setAttribute("class", "headline");

                let elTitleInner;
                if (props.hasOwnProperty("link") && props["link"] != "") {
                    elTitleInner = document.createElement("a");
                    elTitleInner.setAttribute("href", props["link"]);
                    elTitleInner.setAttribute("target", "_blank");
                    elTitleInner.setAttribute("title", "Öffnet neues Fenster");
                } else {
                    elTitleInner = document.createElement("span");
                }
                elTitleInner.innerHTML = "<h3>" + props.title + "</h3>";

                elTitle.appendChild(elTitleInner);
                elPopup.appendChild(elTitle);
            }

            if (props.category) {
                let elCategory = document.createElement("p");
                elCategory.setAttribute("class", "category");
                elCategory.innerHTML = props.category;
                elPopup.appendChild(elCategory);
            }

            if (
                props.hasOwnProperty("ratingstotal") &&
                props["ratingstotal"] > 0
            ) {
                let fullStars = Math.round(props["ratingsavg"]);
                let emptyStars = 5 - fullStars;

                let elRating = document.createElement("div");
                elRating.setAttribute("class", "company-rating");

                let elRatingInnerHTML = "";
                for (var y = 0; y < fullStars; y++) {
                    elRatingInnerHTML +=
                        '<i class="icon icon-star active"></i>';
                }
                for (var x = 0; x < emptyStars; x++) {
                    elRatingInnerHTML += '<i class="icon icon-star"></i>';
                }

                elRatingInnerHTML +=
                    '<b class="rating-average pl-2">' +
                    props["ratingsavg"].toFixed(1).replace(".", ",") +
                    '</b><span class="rating-total">&nbsp;(' +
                    props["ratingstotal"] +
                    ")</span>";

                elRating.innerHTML = elRatingInnerHTML;

                elPopup.appendChild(elRating);
            }

            if (
                props["iframe_width"] &&
                props["iframe_height"] &&
                props["iframe_url"]
            ) {
                let elIFrame = document.createElement("iframe");
                elIFrame.setAttribute(
                    "style",
                    "width:" +
                        props["iframe_width"] +
                        "px;height:" +
                        props["iframe_height"] +
                        "px;border:0)"
                );
                elIFrame.setAttribute("src", props["iframe_url"]);
                elIFrame.setAttribute("allowfullscreen", "");
                elPopup.appendChild(elIFrame);
            }

            if (props.image) {
                let elImage = document.createElement("img");
                elImage.setAttribute("src", props["image"]);
                elImage.setAttribute("alt", "");
                elImage.innerHTML = "<p>" + props.address + "</p>";
                elPopup.appendChild(elImage);
            }

            if (props.hasOwnProperty("address")) {
                let elAddress = document.createElement("div");
                elAddress.setAttribute("class", "address");
                elAddress.innerHTML = "<p>" + props.address + "</p>";
                elPopup.appendChild(elAddress);
            }

            if (props.hasOwnProperty("text")) {
                let elText = document.createElement("p");
                elText.innerHTML = props.text;
                elPopup.appendChild(elText);
            }

            if (
                props["businessHoursSet"] &&
                props["businessHoursSet"] == "true" &&
                (props["businessHoursStatus"] || props["businessHoursText"])
            ) {
                let elBusinesshours = document.createElement("div");
                elBusinesshours.setAttribute(
                    "class",
                    "openingHours status " + props.businessHoursClass
                );
                elBusinesshours.setAttribute("title", "Öffnungszeiten heute");
                let elBusinesshoursIcon = document.createElement("i");
                elBusinesshoursIcon.setAttribute("class", "icon-clock ml-2");

                elBusinesshours.appendChild(elBusinesshoursIcon);
                if (props["businessHoursStatus"]) {
                    let elBusinesshoursStatus = document.createElement("span");
                    elBusinesshoursStatus.setAttribute("class", "status mx-2");
                    elBusinesshoursStatus.appendChild(
                        document.createTextNode(props.businessHoursStatus + " ")
                    );

                    elBusinesshours.appendChild(elBusinesshoursStatus);
                }
                if (props["businessHoursText"]) {
                    let elBusinesshoursText = document.createElement("span");
                    elBusinesshoursText.setAttribute("class", "slot");
                    elBusinesshoursText.appendChild(
                        document.createTextNode(props.businessHoursText)
                    );

                    elBusinesshours.appendChild(elBusinesshoursText);
                }
                elPopup.appendChild(elBusinesshours);
            }

            if (
                props.hasOwnProperty("source") ||
                props.hasOwnProperty("sourceimg")
            ) {
                let elSource = document.createElement("p");
                let elSourceInnerHTML;
                elSource.setAttribute("class", "text-muted small");

                if (props.hasOwnProperty("sourceimg")) {
                    elSourceInnerHTML =
                        '<img src="' +
                        props["sourceimg"] +
                        '" alt="' +
                        props["source"] +
                        '"/>';
                } else {
                    elSourceInnerHTML = props["source"];
                }

                if (
                    props.hasOwnProperty("sourcelink") &&
                    props["sourcelink"] != ""
                ) {
                    elSource.innerHTML =
                        '<a href="' +
                        props["sourcelink"] +
                        '" rel="noopener" target="_blank" title="Öffnet neues Fenster">' +
                        elSourceInnerHTML +
                        "</a>";
                } else {
                    elSource.innerHTML = elSourceInnerHTML;
                }

                elPopup.appendChild(elSource);
            }

            if (
                props.hasOwnProperty("to") ||
                props.hasOwnProperty("phonenumber")
            ) {
                var elFuncs = document.createElement("div");
                elFuncs.setAttribute("class", "functions");

                var target;
                if (props.hasOwnProperty("sid")) {
                    target = "YP:" + props["sid"];
                } else if (props.hasOwnProperty("pid")) {
                    target = "WP:" + props["pid"];
                }
                if (props.hasOwnProperty("to")) {
                    let elDirection = document.createElement("a");
                    elDirection.setAttribute("class", "btn btn-hbd gray");
                    elDirection.setAttribute("href", props["to"]);
                    elDirection.setAttribute("target", "_top");
                    elDirection.innerHTML = "Route planen";
                    elDirection.addEventListener("click", function () {
                        hbdTrackEvent(
                            "get direction" + props.pageType,
                            "click",
                            target,
                            "inmap"
                        );
                    });

                    elFuncs.appendChild(elDirection);
                }

                if (props.hasOwnProperty("phonenumber")) {
                    /*
 <a class="btn-hbd yellow hasIcon " href="tel:+432236379998" target="_top" data-category="Telefonnummer" data-action="call" data-label="YP:609968">
 <i class="icon-phone"></i>
 Anrufen
 </a>
 */
                    let elPhone = document.createElement("div");
                    elPhone.setAttribute("class", "buttonPhone");

                    let elPhoneMobile = document.createElement("a");
                    elPhoneMobile.setAttribute(
                        "class",
                        "d-flex d-md-none btn-hbd yellow hasIcon"
                    );
                    elPhoneMobile.setAttribute(
                        "href",
                        "tel:" + props["phonenumber"]
                    );
                    elPhoneMobile.setAttribute("target", "_top");
                    elPhoneMobile.innerHTML =
                        '<i class="icon-phone"></i>Anrufen';
                    elPhoneMobile.addEventListener("click", function () {
                        hbdTrackEvent(
                            "Telefonnummer_result",
                            "call",
                            target,
                            "inmap"
                        );
                    });

                    let elPhoneButton = document.createElement("a");
                    elPhoneButton.setAttribute(
                        "class",
                        "d-none d-md-block btn btn-hbd yellow fullWidth callPhone hidden ellipsis"
                    );
                    elPhoneButton.setAttribute(
                        "href",
                        "tel:" + props["phonenumber"]
                    );
                    elPhoneButton.setAttribute("target", "_top");
                    elPhoneButton.innerHTML = props["phonenumber"];
                    elPhoneButton.addEventListener("click", function () {
                        hbdTrackEvent(
                            "Telefonnummer_result",
                            "call",
                            target,
                            "inmap"
                        );
                    });

                    let elPhoneShow = document.createElement("button");
                    elPhoneShow.setAttribute(
                        "class",
                        "d-none d-md-flex btn btn-hbd yellow hasIcon fullWidth showPhone switch"
                    );
                    elPhoneShow.innerHTML =
                        '<i class="icon-phone"></i>Nr. anzeigen';
                    elPhoneShow.addEventListener("click", function () {
                        hbdTrackEvent(
                            "Telefonnummer_result",
                            "show",
                            target,
                            "inmap"
                        );
                        this.previousSibling.classList.remove("hidden");
                        this.parentNode.removeChild(this);
                    });

                    elPhone.appendChild(elPhoneMobile);
                    elPhone.appendChild(elPhoneButton);
                    elPhone.appendChild(elPhoneShow);
                    elFuncs.appendChild(elPhone);
                }

                elPopup.appendChild(elFuncs);
            }
        } else {
            // Reverse-Search
            let row1 = document.createElement("div");
            let row2 = document.createElement("div");
            let col1 = document.createElement("div");
            let col2 = document.createElement("div");
            let col3 = document.createElement("div");
            row1.className = row2.className = "row";
            col1.className = "col-22";
            col2.className = col3.className = "col-12 groupPadding";

            let elIcon = document.createElement("img");
            elIcon.setAttribute("src", "/images/mapPins/pin.svg");

            let elText = document.createElement("div");
            elText.innerHTML =
                "<p><b>" +
                marker.place_name.replace(", Österreich", "") +
                "</b></p><p>" +
                marker.center[1] +
                ", " +
                marker.center[0] +
                "</p>";

            let elButtonFrom = document.createElement("button");
            elButtonFrom.className =
                "btn btn-md btn-hbd btn-light-yellow fullWidth setRoutePin";
            elButtonFrom.setAttribute("type", "button");
            elButtonFrom.setAttribute("data-poi-action", "origin");
            elButtonFrom.innerHTML = "Route von hier";
            elButtonFrom.addEventListener("click", () => {
                this.map.setPin("origin", marker);
                this.map.planRoute.setRouteItem("origin", marker);
                this.map.checkRouteComplete();
            });

            let elButtonTo = document.createElement("button");
            elButtonTo.className =
                "btn btn-md btn-hbd btn-light-yellow fullWidth setRoutePin";
            elButtonTo.setAttribute("type", "button");
            elButtonTo.setAttribute("data-poi-action", "destination");
            elButtonTo.innerHTML = "Route hierher";
            elButtonTo.addEventListener("click", () => {
                this.map.setPin("destination", marker);
                this.map.planRoute.setRouteItem("destination", marker);
                this.map.checkRouteComplete();
            });

            row1.appendChild(col1).appendChild(elIcon);
            row1.appendChild(col1).appendChild(elText);
            elPopup.appendChild(row1);
            row2.appendChild(col2).appendChild(elButtonFrom);
            row2.appendChild(col3).appendChild(elButtonTo);
            elPopup.appendChild(row2);
        }

        return elPopup;
    }
}